export { default } from './HistoryEntry';
